import { LegacyMap, has, rows } from './prism-new-legacy-maps.helpers';

/**
 * bot-builder (chatbot builder, formerly the whitelabel gateway) legacy maps. Keys are prism-new
 * paths as MicroServiceHttpService sends them (see bot-builder-routing.ts); every other bot-builder
 * endpoint already answers with the gateway's `data`.
 */
export const BOT_BUILDER_LEGACY_MAPS: Record<string, LegacyMap> = {
  // prism-new sends a missing last name as null; the security tab prints it next to the first name.
  'GET /bot-builder/users': (d) =>
    has(d, 'users')
      ? { data: { ...d, users: rows(d.users).map((u: any) => ({ ...u, lastName: u.lastName ?? '' })) } }
      : { data: d },
};
